(() => {
  // Keep the native Shopify consent controls accessible from the custom footer.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.privacyBanner.showPreferences().catch(() => {
      window.location.href = '/policies/privacy-policy#shopifyReshowConsentBanner';
    });
  }, true);
  const config = document.getElementById('pluffi-eu-app-copy');
  if (!config) return;
  const copy = JSON.parse(config.textContent);
  if (!copy.heading || copy.heading === 'FALL DEAL DAYS') return;
  const lang = document.documentElement.lang.slice(0, 2);
  const priceLabels = {fr:['Prix :','Prix habituel :'],it:['Prezzo:','Prezzo abituale:'],es:['Precio:','Precio habitual:'],de:['Preis:','Regulärer Preis:']}[lang] || ['Price:','Regular price:'];
  const translate = () => {
    document.querySelectorAll('.kaching-bundles__bar-price, .kaching-bundles__bar-full-price').forEach(el => {
      const label = priceLabels[el.classList.contains('kaching-bundles__bar-full-price') ? 1 : 0];
      if (el.getAttribute('data-a11y-label') !== label) el.setAttribute('data-a11y-label', label);
    });
    document.querySelectorAll('.kaching-bundles__block-title').forEach(el => {
      if (el.textContent.trim() !== 'FALL DEAL DAYS' || el.dataset.pluffiEuHeading === copy.heading) return;
      // Preserve the app-owned text node so its reactive renderer is not retriggered.
      el.dataset.pluffiEuHeading = copy.heading;
      el.setAttribute('aria-label', copy.heading);
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '3');
    });
    document.querySelectorAll('.kaching-bundles__bar-most-popular__content').forEach(el => {
      if (el.textContent.trim() !== 'BLACK FRIDAY' || !copy.offerLabel || el.dataset.pluffiEuOffer === copy.offerLabel) return;
      el.dataset.pluffiEuOffer = copy.offerLabel;
      el.setAttribute('aria-label', copy.offerLabel);
    });
  };
  const style = document.createElement('style');
  style.textContent = '.kaching-bundles__block-title[data-pluffi-eu-heading]{font-size:0!important}.kaching-bundles__block-title[data-pluffi-eu-heading]::before{content:attr(data-pluffi-eu-heading)!important;font-size:14px!important;line-height:1.4!important;display:block!important;flex:0 0 auto!important;height:auto!important;width:auto!important;background:none!important;border:0!important;margin:0 10px 0 0!important}.kaching-bundles__bar-most-popular__content[data-pluffi-eu-offer]{font-size:0!important;white-space:nowrap!important}.kaching-bundles__bar-most-popular__content[data-pluffi-eu-offer]::before{content:attr(data-pluffi-eu-offer)!important;font-size:12px!important;display:inline!important;position:static!important;width:auto!important;height:auto!important;border:0!important;transform:none!important;background:none!important;white-space:nowrap!important;line-height:1.2!important}';
  document.head.appendChild(style);
  translate();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    setTimeout(() => { pending = false; translate(); }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
